import { Injectable } from '@angular/core';
import { UserService } from '../../core/services/user.service';
import { LoadingService } from '../../common/layout/loading.service';
import { NotificationService } from '../../common/layout/notification.service';
import { AccountService, GoldfingerService } from '../../api';
import { GenericRequestHandlerService } from '../../core/services/generic-request-handler.service';
import { isNullOrUndefined } from 'util';
import { Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private _urlBeforeLogin: string;

    constructor(
        private userService: UserService,
        private loadingService: LoadingService,
        private notificationService: NotificationService,
        private api: AccountService,
        private genericRequestHandler: GenericRequestHandlerService,
        private goldfingerService: GoldfingerService
    ) {

    }

    get urlBeforeLogin(): string {
        return this._urlBeforeLogin;
    }

    set urlBeforeLogin(value: string) {
        this._urlBeforeLogin = value;
    }

    public remindPassword(email: any, successCallback?: Function, failCallback?: Function) {
        this.loadingService.start();
        const sub: Subscription =
            this.api.passwordResetStartHandler(email)
                .subscribe(res => {
                        this.notificationService.success("Proces przypominania hasła został uruchomiony");
                        if (!isNullOrUndefined(successCallback)) {
                            successCallback(res);
                        }
                    },
                    err => {
                        this.loadingService.stop();
                        sub.unsubscribe();
                        this.notificationService.error(err['errorMessage']);
                        if (!isNullOrUndefined(failCallback)) {
                            failCallback(err);
                        }
                    },
                    () => {
                        this.loadingService.stop();
                        sub.unsubscribe();
                    });
    }

    public remindPasswordReset(content: any) {
        return this.genericRequestHandler.callRequest(
            this.api.passwordResetHandler(content),
            'Hasło zostało zmienione pomyślnie'
        );
    }
    public registerPassword(content: any) {
        return this.genericRequestHandler.callRequest(
            this.api.createPasswordHandler(content),
            'Hasło zostało zmienione pomyślnie'
        );
    }
    public newPassword(content: any) {
        return this.genericRequestHandler.callRequest(
            this.api.passwordResetHandler(content),
            'Hasło zostało zmienione pomyślnie'
        );
    }

    public getGoldfingerConfiguration() {
        return this.goldfingerService.generateAuthorizationQR();
    }
}
